
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import useTranslation from 'next-translate/useTranslation';
import { GetStaticProps } from 'next/types';
import React from 'react';
import { OfficeContact } from '../components/OfficeContact';
import Image from 'next/image';

function Representants() {
  const { t } = useTranslation();
  return (
    <div className=''>
      <h3 className='subtitle my-6 text-center text-2xl'>
        {t('common:Represented by')}:
      </h3>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2'>
        <div className='flex flex-col items-center space-y-2'>
          <div className='relative h-[15em] w-[15em] rounded-full border-4 border-orange-500'>
            <Image
              src='/carsten-bg.png'
              alt='company representant'
              fill
              className='rounded-full border-8 border-orange-500 object-cover'
            />
          </div>
          <p className='font-bold'>Carsten Hormes</p>
          <p>{t('common:Managing Director')}</p>
          <p>{t('common:Engineering')}</p>
        </div>
        <div className='flex flex-col items-center space-y-2'>
          <div className='relative h-[15em] w-[15em] rounded-full border-4 border-orange-500'>
            <Image
              src='/benedikt.png'
              alt='company representant'
              fill
              className='rounded-full border-8 border-orange-500 object-contain'
            />
          </div>
          <p className='font-bold'>Benedikt Ruf</p>
          <p>{t('common:Managing Director')}</p>
          <p>{t('common:Marketing')}</p>
        </div>
      </div>
    </div>
  );
}

function LegalNotes() {
  const { t } = useTranslation();
  return (
    <div className=''>
      <h3 className='title'>{t('common:Legal Notes')}</h3>
      <p>{t('common:Responsible for content')}</p>
      <br />
      <p>{t('common:Sales tax id law')}</p>
      <p>{t('common:id tax 1')}</p>
      <p>{t('common:id tax 2')}</p>
      <br />
      <p>{t('common:Commercial Register')}:</p>
      <p>{t('common:commercial_register_content')}</p>
      <p>{t('common:commercial_register_content_2')}</p>
      <br />
      <p>{t('common:regulation_ODR_title')}</p>
      <p>{t('common:regulation_ODR_content')}</p>
    </div>
  );
}

function Imprint() {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col items-center bg-white'>
      <div className='flex max-w-7xl flex-col justify-center space-y-4 bg-white px-12 py-4 lg:pb-52'>
        <div className=''>
          <h4 className='title'>{t('common:Imprint')}</h4>
          <div className=''>
            <div className='rounded-xl border-2 shadow-xl'>
              <div className='grid md:grid-cols-3'>
                <div className='flex flex-col p-4 '>
                  <h3 className='subtitle mt-4 pb-4 text-center text-2xl md:text-left'>
                    {t('common:Registered Office')} :
                  </h3>
                  <div className='mb-2 text-center md:mt-8 md:text-left'>
                    <OfficeContact />
                  </div>
                </div>
                <div className='min-h-[16em] md:col-span-2'>
                  <iframe
                    width={425}
                    height={350}
                    frameBorder={0}
                    scrolling='no'
                    marginHeight={0}
                    marginWidth={0}
                    src='https://maps.google.com/maps?q=BEVMAQ GmbH Mühlenhorst 8&output=embed'
                    className='relative h-full w-full'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Representants />
        <LegalNotes />
      </div>
    </div>
  );
}

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
export default Imprint;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/imprint',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  